<template>
  <modal :show.sync="openModal">
    <h4 slot="header" class="title title-up">{{ $t(title)  }}</h4>

    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(execAction)">

        <div class="row" v-if="action === 'declinar'">
          <div class="col-sm-12">
            <el-select v-model="reason" :placeholder="$t('app.modules.orders.headers.reason')" size="large">
              <el-option
                v-for="declinacion in declinaciones"
                :key="declinacion.idDeclinacion"
                :label="declinacion.nombreMotivo"
                :value="declinacion.nombreMotivo">
              </el-option>
            </el-select>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-sm-12">
            <ValidationProvider
              name="required"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="
                  failed ? $t('app.validation.required') : null
                "
                :hasSuccess="passed"
                :label="$t('app.modules.orders.headers.reason')"
                :placeholder="$t('app.modules.orders.headers.reason')"
                v-model="reason"
              >
              </fg-input>
            </ValidationProvider>
          </div>
        </div>

        <div class="row" v-if="action === 'declinar'">
          <div class="text-danger" style="font-size: 11px; margin: 0 10px;">*{{ $t('app.general.notify_client') }}</div>
        </div>
        <div class="row" v-else>
          <div class="text-danger" style="font-size: 11px; margin: 0 10px;">*{{ $t('app.general.notify_seller') }}</div>
        </div>

        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancel">{{ $t("app.buttons.cancel") }}</n-button>
          <n-button native-type="submit" type="primary">{{ $t("app.buttons.save") }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>

<script>
import {mapState} from "vuex";
import { getResponse } from "@/util/utilities";

export default {
  components: {},
  computed: {
    ...mapState(["user"])
  },
  data() {
    return {
      title: "",
      action: "devolver",
      openModal: false,
      reason: "",
      idPedido: 0,
      declinaciones: []
    }
  },
  mounted() {
    this.getDeclinaciones();
    EventBus.$on("devolverPedido",  row => {
      this.title = "app.modules.orders.form.return_order";
      this.action = "devolver";
      this.idPedido = row.idPedido;
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.openModal = true;
    });
    EventBus.$on("declinarPedido",  row => {
      this.title = "app.modules.orders.form.cancel_order";
      this.action = "declinar";
      this.idPedido = row.idPedido;
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      this.$swal.close();
      this.openModal = true;
    });
  },
  methods: {
    async execAction(){
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      try{
        if(!!!this.reason) throw new Error(this.$t('app.modules.orders.errors.no_reason'));

        let data = new FormData();
        data.append('idPedido', this.idPedido);
        data.append('motivo', this.reason);

        let response;
        switch (this.action){
          case "devolver": response = await this.returnOrder(data); break;
          case "declinar": response = await this.cancelOrder(data); break;
        }

        if(response){
          EventBus.$emit("reload-items");
          this.cancel();
          this.notifyMessage("success", this.$t("app.promps.save_success"));
        }
        else this.notifyMessage("danger", this.$t("app.promps.error"));
      }
      catch (e){
        this.notifyMessage('danger', e.message);
      }



      this.$swal.close();
    },
    async returnOrder(data){
      let request = await this.$http.post(route("Pedidos/devolverPedido"), data);
      return getResponse(request);
    },
    async cancelOrder(data){
      let request = await this.$http.post(route("Pedidos/declinarPedido"), data);
      return getResponse(request);
    },
    async getDeclinaciones()
    {
      let payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };

      let request = await this.$http.post(route("DeclinacionPedido/getDeclinacionPedido"), payload);
      let response = getResponse(request, null);
      console.log(request);

      if(response != null){
        this.declinaciones = response.declinacionPedido;
      }
    },
    cancel(){
      this.idPedido = 0;
      this.reason = "";
      this.openModal = false;
    }
  }
}
</script>

<style scoped>
.el-select--large {
  width: 100% !important;
}
</style>
